'use client';

import { Box, Tooltip } from '@mui/material';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  title: ReactNode | string;
  enableTooltip?: boolean;
}

export default function WithTooltip({ children, title, enableTooltip = true }: Props) {
  if (!enableTooltip) {
    return <>{children}</>;
  }

  return (
    <Tooltip
      title={title}
      followCursor
    >
      <Box>{children}</Box>
    </Tooltip>
  );
}
